export const environment = {
  production: false,
  // BASE_URL: 'http://127.0.0.1:1339/',
  // BASE_URL: 'http://192.168.0.10:1339/'
  BASE_URL: 'https://controlapi-dev.truphle.com/',
};
